import React, { useContext } from "react";
import { Modal } from "react-bootstrap";
import Moment from "react-moment";
import "./ModalUltimos7.css";

const ModalAdicion = ({ show, setShow, ultimas7 }) => {
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="modal-90wUltimos7"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="AcreditadoDetalleModalTitle">
          Últimas 7 gestiones registradas en IBCEES
          <h2>Registro de las ultimas gestiones para este expediente</h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {ultimas7.map((item) => (
          <div className="Ultimas7Item__container">
            <div>
              <h1>
                {item.Nombre} <span>* Exp. {item.AcreditadoId}</span>
              </h1>
              <h2>
                Comentario: <span>{item.Comentario}</span>
              </h2>
              <h2>
                Tipo de gestión: <span>{item.TipoGestionNombre}</span>
              </h2>
            </div>
            <div>
              <h2>
                <span>Gestor: {item.ClaveGestor}</span>
              </h2>
            </div>
            <div>
              <h1>
                <Moment locale="es" format="DD-MMM-YYYY" date={item.Fecha} />
              </h1>
            </div>
          </div>
        ))}
        <div className="btnCerrarModalUltimos7">
          <button
            className="btnNuevaGestion"
            onClick={() => {
              setShow(false);
            }}
          >
            Cerrar
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalAdicion;
